
<template>
<div>
  <section class="wrapper charity-detail">
    <div class="charity-detail-header">
      <div class="charity-status">
        <h1> {{ data.name }} </h1>
        <dl v-if="data.agreement_document">
          <dd class="data-content"><a @click="downloadAgreement"><span class="icon fal fa-file-pdf" aria-hidden="true"></span> Download Agreement<!-- Link to download agreement document --></a></dd>
        </dl>
      </div>
      <dl>
        <dt class="data-label">Vehicle Count YTD</dt>
        <dd class="data-content">{{data.ytd_data.vehicle_count_ytd}}</dd>
      </dl>
      <dl>
        <dt class="data-label">Proceeds YTD</dt>
        <dd class="data-content">{{data.ytd_data.proceeds_ytd}}</dd>
      </dl>
      <dl>
        <dt class="data-label">Avg. Car Proceeds YTD</dt>
        <dd class="data-content">{{data.ytd_data.avg_car_proceeds_ytd}}</dd>
      </dl>
      <dl>
        <dt class="data-label">Avg. Sales Price YTD</dt>
        <dd class="data-content">{{data.ytd_data.avg_car_value_ytd}}</dd>
      </dl>
      <dl>
        <dt class="data-label">Avg. Donor Age</dt>
        <dd class="data-content">{{data.ytd_data.avg_donor_age}}</dd>
      </dl>
      <dl>
        <dt class="data-label">Top Donation Zip Code</dt>
        <dd class="data-content">{{data.ytd_data.top_donation_zip}}</dd>
      </dl>
    </div>
    <chc-tab-control>
      <chc-tab-pane label="Proceeds">
        <charity-proceeds :charityId="data.id"></charity-proceeds>
      </chc-tab-pane>
      <chc-tab-pane label="Vehicles">
        <charity-vehicles :downloadCSV="true"></charity-vehicles>
      </chc-tab-pane>
  </chc-tab-control>
</section>
</div>
</template>

<script>
import CharityProceeds from '@/components/Charity/CharityProceeds'
import CharityVehicles from '@/components/Charity/CharityVehicles'
import store from '@/store'
import auth from '@/auth'
import helpers from '@/helpers'

export default {
  name: 'CharityView',
  data () {
    return {
      data: {
        ytd_data: {}
      },
      user: auth.user,
    }
  },
  props: [],
  beforeRouteEnter (to, from, next) {
    let charityData = null
    Promise.all([
      store.dispatch('syncConstants'),
      store.dispatch('syncSummary'),
      store.functions.charity.getCharity(null, (response) => { charityData = response.data.data })
    ]).then(() => {
      next(vm => vm.setData(charityData))
    })
  },
  methods: {
    setData (data) {
      this.data = data
    },
    downloadAgreement () {
      store.functions.charity.downloadAgreement(this.data.id, (error) => {
        console.log(error)
      }).then((response) => {
        helpers.openAsDownload(response.data, this.data.agreement_document_name)
      })
    },
  },
  computed: {
  },
  components: {
    CharityProceeds,
    CharityVehicles
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
    opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transition: opacity 3s;
    opacity: 0;
}
.charity-detail-header {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 2rem;
  .charity-status {
    margin-right: 2rem;
    width: 300px;
    .field {
      width: 300px;
    }
  }
  h1 {
    margin: 0 0 1rem 0;
    text-transform: none;
  }
  dl {
    margin: 0 3rem 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Charity/CharityView.vue